import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { AddSupplierData } from '../features/selfservice/supplier/add'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const AddSupplierPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <AddSupplierData />
    </ErrorBoundary>
  )
}
